/**
 * Pixel IDs read from Vite build-time env vars.
 *
 * For v1 each Cloudflare Pages project sets these per-brand in its
 * environment settings. A future iteration (NX-9444+) may move pixel
 * config into D1 so the admin dashboard can manage IDs without a redeploy.
 */

export type PixelConfig = {
  readonly metaPixelId: string | null;
  readonly tiktokPixelId: string | null;
  readonly gtmContainerId: string | null;
};

export const readPixelConfig = (): PixelConfig => ({
  metaPixelId: import.meta.env.VITE_META_PIXEL_ID || null,
  tiktokPixelId: import.meta.env.VITE_TIKTOK_PIXEL_ID || null,
  gtmContainerId: import.meta.env.VITE_GTM_CONTAINER_ID || null,
});
